<template>
  <header class="site-header">
    <div class="site-header__inner">
      <a
        class="site-brand"
        href="https://erdogan.edu.tr/Website/Default.aspx"
        target="_blank"
        rel="noopener"
        aria-label="Recep Tayyip Erdoğan Üniversitesi"
      >
        <img
          src="/assets/img/rteu-logo.png"
          alt="Recep Tayyip Erdoğan Üniversitesi"
        />
      </a>
      <nav aria-label="Site bağlantıları">
        <ul class="site-nav">
          <li>
            <a
              href="https://erdogan.edu.tr/Website/Default.aspx"
              target="_blank"
              rel="noopener"
              >Anasayfa</a
            >
          </li>
          <li>
            <a
              href="http://lisansustu.erdogan.edu.tr/"
              target="_blank"
              rel="noopener"
              >Lisansüstü Eğitim Enstitüsü</a
            >
          </li>
          <li>
            <a
              href="http://ogrenci.erdogan.edu.tr/adaylogin"
              target="_blank"
              rel="noopener"
              >Aday Başvuru Sayfası</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
};
</script>

<style scoped></style>
